import type { ContentCellProps } from '../../components/content-cell';
import type { StatusCellProps } from '../../components/status-cell';
import { getColumnDefContent } from './content';
import { getColumnDefDateInMonth } from './dateinmonth';
import { getColumnDefDateRange } from './daterange';
import { getColumnDefDateTime } from './datetime';
import type { DurationCellValue } from './duration';
import { getColumnDefDuration } from './duration';
import { getColumnDefFin } from './fin';
import { getColumnDefPercentage } from './percentage';
import type { ScoreCellProps } from './score';
import { getColumnDefScore } from './score';
import { getColumnDefStatus } from './status';
import { getColumnDefTag } from './tag';
import { getColumnDefTags, type TagItem } from './tags';
import { getColumnDefTextList } from './textlist';

export const cellTemplates = {
	content: getColumnDefContent,
	datetime: getColumnDefDateTime,
	dateinmonth: getColumnDefDateInMonth,
	textlist: getColumnDefTextList,
	daterange: getColumnDefDateRange,
	duration: getColumnDefDuration,
	fin: getColumnDefFin,
	percentage: getColumnDefPercentage,
	status: getColumnDefStatus,
	score: getColumnDefScore,
	tag: getColumnDefTag,
	tags: getColumnDefTags,
};

export type DataGridColumnPredefinedCellTypeConfig = {
	content: { type: 'content'; value: ContentCellProps };
	datetime: { type: 'datetime'; value: ContentCellProps };
	dateinmonth: { type: 'dateinmonth'; value: ContentCellProps };
	daterange: { type: 'daterange'; value: ContentCellProps };
	textlist: { type: 'textlist'; value: ContentCellProps };
	duration: { type: 'duration'; value: DurationCellValue };
	fin: { type: 'fin'; value: number };
	status: { type: 'status'; value: StatusCellProps | string };
	tag: { type: 'tag'; value: TagItem };
	tags: { type: 'tags'; value: TagItem[] };
	score: { type: 'score'; value: ScoreCellProps };
	percentage: { type: 'percentage'; value: number };
};
